package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.ShiftFinancialsDto
import com.evoapps.evoshift.domain.model.ShiftFinancials

class ShiftFinancialsMapper(
    private val ratesSnapshotMapper: RatesSnapshotMapper,
    private val shiftCostsMapper: ShiftCostsMapper
) {

    fun toDomain(dto: ShiftFinancialsDto): ShiftFinancials {
        return ShiftFinancials(
            shiftId = dto.shiftId,
            rosterId = dto.rosterId,
            dailyRecordId = dto.dailyRecordId,
            date = dto.date,
            ratesSnapshot = ratesSnapshotMapper.toDomain(dto.ratesSnapshot),
            costs = shiftCostsMapper.toDomain(dto.costs),
            userId = dto.userId
        )
    }

    fun toDto(domain: ShiftFinancials): ShiftFinancialsDto {
        return ShiftFinancialsDto(
            shiftId = domain.shiftId,
            rosterId = domain.rosterId,
            dailyRecordId = domain.dailyRecordId,
            date = domain.date,
            ratesSnapshot = ratesSnapshotMapper.toDto(domain.ratesSnapshot),
            costs = shiftCostsMapper.toDto(domain.costs),
            userId = domain.userId
        )
    }
}
